import CommandViewModel, {
  CommandName,
} from '../../services/commands/CommandViewModel';
import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';

export const getDatasetCommands = (
  state: AppState,
  datasetId: UniqueId
): CommandViewModel[] | undefined => state.commands[datasetId]?.commands;

export const getIsCommandsCreated = (
  state: AppState,
  datasetId: UniqueId
): boolean => Boolean(getDatasetCommands(state, datasetId));

export const getDatasetCommandsScheduled = (
  state: AppState,
  datasetId: UniqueId
): CommandName[] | undefined => state.commands[datasetId]?.pending;
